"use client";

import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import ProductCard from "./product-card";

interface ProductItem {
  text: string;
}

export default function Products() {
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, { once: true });

  const services1: ProductItem[] = [
    { text: "Re-Energize (Hydration, B-Vitamins, and Electrolytes)" },
    { text: "Stomach Protection" },
    { text: "Hangover Relief" },
  ];

  const services2: ProductItem[] = [
    { text: "Recover Faster from Illness & Boost Energy" },
    { text: "Strengthen Immune Response" },
    { text: "Reduce the Duration of Cold or Flu" },
  ];

  const services3: ProductItem[] = [
    { text: "Rapidly Rehydrate After Diarrhea and Vomiting" },
    { text: "Relieve Nausea and Stop Vomiting" },
    { text: "Relieve Stomach Cramps" },
  ];

  return (
    <div className='min-h-screen  py-12 lg:py-0 lg:mb-12'>
      {/* Header Section */}
      <div className='py-6 lg:py-0 lg:px-[130px]'>
        <motion.div ref={headerRef} initial={{ opacity: 0, y: 100 }} animate={isHeaderInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, ease: "easeOut" }} className='lg:py-10 px-4 lg:px-0'>
          <div className=' lg:w-full mx-auto'>
            <h1 className='text-4xl lg:text-4xl font-bold text-[#4FBAA8] mb-6 lg:w-[950px] leading-tight'>We provide :</h1>
            <p className='text-gray-600 text-lg lg:text-xl max-w-4xl leading-relaxed'>
              {/* With multiple clinic locations focused on natural and effective healing, we produce our own line of trusted herbal medicines. Each facility is designed for comfort, equipped with clean and modern treatment rooms, ensuring a
              safe and holistic healthcare experience for every patient. */}
              
            </p>
          </div>
        </motion.div>
      </div>

      {/* Product Cards Section */}
      <div className='py-2 lg:py-0 px-4 lg:px-0'>
        <div className=' lg:px-[130px] mx-auto space-y-12'>
          <ProductCard
            title='HANGOVER IV DRIP'
            description='The Hangover Relief IV Drip Is a Fast-Acting Intravenous Therapy Designed To:'
            services={services1}
            imageSrc='/images/products/product_red.webp'
            imageAlt='HANGOVER IV DRIP (RED INFUSE)'
          />

          <ProductCard
            title='IMMUNE BOOSTER IV DRIP'
            description='The Immune Booster IV Drip Is a Formulated Intravenous Infusion Designed To:'
            services={services2}
            imageSrc='/images/product_2.webp'
            imageAlt='IMMMUNE BOOSTER IV DRIP'
          />

          <ProductCard
            title='BALI BELLY IV DRIP '
            description='The Bali Belly IV Drip Is a Targeted Intravenous Therapy Designed To:'
            services={services3}
            imageSrc='/images/products/product_green.webp'
            imageAlt='BALI BELLY IV DRIP (GREEN INFUSE)'
          />
        </div>
      </div>
    </div>
  );
}

export { ProductCard };
